import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table, Modal
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import XLSX from 'xlsx';
import { MDBDataTable } from 'mdbreact';
import * as FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import Util from '../../../Common/util';
import API from '../../../Common/api';

import './styles.css';
import LoadingOverlay from 'react-loading-overlay';
import styled, { css } from "styled-components";
import DatePicker from "react-datepicker";
import DarkBackground from '../../../Common/backgroundLoader';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import exportToCSV from '../../../Common/exportcsv';
import Overlay from '../../../Common/overlay';
import EmptyDataIcon from '../../../../images/empty_data_icon.png'
import DownloadIcon from '../../../../images/download_icon.svg'




var url = window.location.hostname;
var port = window.location.port;
var From_Date_val;
var to_Date_val;





const exportToCSVData = (csvData,fileName) => {
  // const ws = XLSX.utils.json_to_sheet(csvData);
  var Heading = []
  if(fileName == "Putaway Detailed Report"){
    Heading = [['Batch','Invoice Number',	'ASN Number',	'PO Number',	'Client',	'Product Code',	'Product Name',	'MRP',	'UPC',	'Putaway Qty',	'Invoiced Qty'	,'Total Received Qty',	'Received CLD Qty', 'Received Loose Qty',	'Confirmed Putaway Qty',	'Putaway CLD Qty',	'Putaway Loose Qty', 'PKM',	'PO Date',	'Inbound Del Date',	'Putaway Date',	'Putaway Through',	'Putaway User', 'Product scan time',	'Bin scan time',	'Putaway Completion Time',	'Primary suggested Bin Id',	'Actual Scanned Bin Id']];}
  if(fileName == "Putaway Consolidated Report"){
    Heading = [['Batch','PO Date',	'Putaway Date',	'Invoice Number',	'ASN Number','PO Number',	'Client',	'Putaway completion percentage',	'SKU Count',	'Total Cld Count',	'Total Loose Count', 'Total Received Qty',	'Putaway CLD Count',	'Putaway Loose Count','Total Putaway Qty', 'Putaway Short Qty','Putaway Start Time',	'Putaway End Time',	'Assigned User Ids','status']];}
  exportToCSV(csvData,fileName, Heading)
}


class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.createCookie = this.createCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.fetchInventoryData = this.fetchInventoryData.bind(this);
    this.indexOfExt = this.indexOfExt.bind(this);
    this.processData = this.processData.bind(this);

    this.state = {
      loading_overlay: false,
      showPassword: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      fileNameVal: 'masterFile',
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      ErrorRowData: [],
      loading: false,
      isLoading: true,
      show_process_data: true,
      from_date: "",
      to_date: "",
      value: '',
      error: '',
      value: 'select',
      selectedFileType: '',
      orderData :[],
      tableRowsMap:[],
      tableRowsMap1:[],
      detailed_view : true,
      consolidated_view :"",
      showFetchDispatchData: false,
      showFetchDispatchData1:false,
      from_date: null,
      to_date: null,
      showFromErr: false,
      showToErr: false,
      dateRangeError: false, 
      toDateError: "",
      showfilterstatus : false,
      fromDateError: "",
      asn_number : ''
    };
  }

  handleChange = (evt)=>{
    if(evt.target.value == "detailed_view"){
      this.setState({detailed_view : true,consolidated_view :false,tableRowsMap:[],tableRowsMap1:[],showFetchDispatchData1:false, showfilterstatus: false });
    }
    else if (evt.target.value == "consolidated_view"){
      this.setState({detailed_view : false,consolidated_view :true,tableRowsMap:[],tableRowsMap1:[],showFetchDispatchData : false, showfilterstatus: false });
    }

  }
  onAsnChange = (evt) =>{
    this.setState({
      asn_number: evt.target.value
    })

  }
  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };

  componentDidMount() {
    // this.fetchInventoryData();
  }


  componentWillMount() {

    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090"
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088"
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";

    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie('token');
    var location = this.getCookie('selectedLocation');
    var username = this.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: location
    })

    localStorage.setItem('userName', username);
  }

  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
    document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(';');
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  indexOfExt(list, item) {
    var len = list.length;

    for (var i = 0; i < len; i++) {
      var keys = Object.keys(list[i]);
      var flg = true;
      for (var j = 0; j < keys.length; j++) {
        var value = list[i][keys[j]];
        if (item[keys[j]] !== value) {
          flg = false;
        }
      }
      if (flg == true) {
        return i;
      }
    }
    return -1;
  }

  convertDate = (inputFormat) => {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(inputFormat)
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-')
  }

  FromDateChange = date => {
    this.setState({
      from_date: date,
      dateRangeError: false, // Reset the error when "From Date" changes
      dateOrderError: false, // Reset the date order error
    });
    if (date) {
      From_Date_val = this.convertDate(date);
    } else {
      this.setState({ to_date: "" });
      From_Date_val = "";
    }


    if (this.state.to_date && date) {
      const fromDate = new Date(date);
      const toDate = new Date(this.state.to_date);
      const timeDifference = toDate - fromDate;
      const dayDifference = timeDifference / (1000 * 3600 * 24); // Convert to days

      // If the difference is less than 15 days, show error
       if (fromDate > toDate) {
        // If From Date is greater than To Date, show error
        this.setState({
          dateOrderError: true,
           from_date: null, 
           todateError: "",
           fromDateError: "From Date should be less than To Date"
        });
      }
      console.log("dateOrderError",dayDifference)
      if (dayDifference > 15) {
        this.setState({
          dateOrderError: true, // Show error if the date range is less than 15 days
          from_date: null, // Reset From Date if the range is invalid
          fromDateError: "From Date should always be within 15 days of the To Date"
        });
      }
    }
  };

  // To date change handler
  ToDateChange = date => {
    if (date && this.state.from_date) {
      const fromDate = new Date(this.state.from_date);
      const toDate = new Date(date);
      const timeDifference = toDate - fromDate;
      const dayDifference = timeDifference / (1000 * 3600 * 24);
      if (fromDate > toDate) {
        // If From Date is greater than To Date, show error
        console.log("fromDate", fromDate, "toDate", toDate)
        this.setState({
          dateRangeError: true,
           to_date: null, 
           todateError: "",
           toDateError: "To Date should be greater than From Date"
        });
        return false;
      }

      if (dayDifference > 15) {
        this.setState({
          dateRangeError: true,
          toDateError: "You cannot select more than 15 days",
          to_date: null, // Reset to_date if range exceeds 15 days
        });
      } else {
        this.setState({
          to_date: date,
          showToErr: false,
          dateRangeError: false,
        });
      }
    } else {
      this.setState({
        to_date: date,
        showToErr: false,
        dateRangeError: false,
      });
    }

    if (date) {
      to_Date_val = this.convertDate(date);
    } else {
      this.setState({ to_date: "" });
      to_Date_val = "";
    }
  };


  fetchInventoryData() {

    this.setState({
      // showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      showFetchTesterData: false,
      loading_overlay: true
    })
    var view_type = ""
    if (this.state.detailed_view == true){
      view_type = "detailed_view"
    }
    else if (this.state.consolidated_view == true){
      view_type = "consolidated_view"
    }

    const payload = {
      location: this.state.selectedLocation,
      fromdate: From_Date_val,
      todate: to_Date_val,
      request_type: "view",
      "view_type":view_type,
      asn_no : this.state.asn_number
    };
    addAnalytics('Report', 'Putaway Report View', payload);
    API.post('/reports/putawayreports/v1/', { param: payload })
      .then(response => response.data)

      .then(data => {

        if (data.data_type == "detailed_view"){
          this.setState({
            tableRowsMap: this.assemblePosts(data.data),
            showFetchDispatchData: true,
            dispatch_status: false,
            loading: false,
            showfilterstatus:true
          });

        }
        if (data.data_type == "consolidated_view"){
          this.setState({
            tableRowsMap1: this.assemblePosts1(data.data),
            showFetchDispatchData1: true,
            dispatch_status: false,
            loading: false,
            showfilterstatus : true
          });
        }

      })

      .then(async () => {

        this.setState({  isLoading: false })

       

      });
  }
  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.orderData});
    } else {
      
      var value = this.state.orderData.filter(
        (val) =>{
        return Object.keys(val).some(key =>{
          var data = ""
          if (val[key] == null ) {
            data = ""
          } 
          else {
            data = val[key]
          }
          
          return data.toString().toLowerCase().includes(evt.toLowerCase()) 
        })
        }
        );
      
        this.setState({
          filtered_orderData: value,
        });
      }
    };
  downloadReport = () => {
    //this.setState({loading:true})
    const payload = {
      location: this.state.selectedLocation,
      fromdate: From_Date_val,
      todate: to_Date_val,
      request_type: "download"
    };

    API.post('/reports/putawayreports/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          loading: false
        });

        window.location.href = data.data[0]
      })
      .catch(function (error) { });
  };

  assemblePosts = (data) => {

    let posts = data.map((post) => {
      var status = ""
      if (post.status == true) {
        status = "Active"
      } else { status = " Not Active" }
      // var statuss = ""
      // if (post.status == 0){
      //   statuss = "Created"
      // }
      // else if(post.status == 1){
      //   statuss = "Hold"
      // }
      // else if (post.status == 2){
      //   statuss = "Assigned"
      // }
      // else if (post.status == 3){
      //   statuss = "Confirmed"
      // }
      // else if(post.status == 111){
      //   statuss = "Canceled"
      // }
      // else if (post.status == 11){
      //   statuss = "Short Closed"
      // }
      return (

        {
          batch: post.batch_number,
          invoice_number : post.invoice_number,
          asn_number : post.asn_number,
          po_number : post.po_number,
          client: post.client,
          product_code: post.product_code,
          product_name: post.product_name,
          mrp: post.mrp,
          upc:post.upc,
          total_qty: post.total_qty,
          invoiced_qty: post.invoiced_qty,
          received_total_qty : post.received_total_qty,
          received_cld_qty :post.received_cld_qty,
          received_loose_qty : post.received_loose_qty,
          total_putaway_qty :post.putaway_total_qty,
          putaway_cld_qty :post.putaway_cld_qty,
          putaway_loose_qty :post.putaway_loose_qty,
          // putaway_short_qty : post.putaway_short_qty,
          pkm: post.pkd,
          po_date:post.po_date,
          inbound_del_date: post.inbound_del_date,
          putaway_date:post.putaway_date,
          putaway_through: post.putaway_through,
          putaway_user: post.putaway_user,
          product_scan_time: post.product_scan_time,
          bin_scan_time : post.bin_scan_time,
          putaway_completion_time: post.putaway_completion_time,
          suggested_bin_id:post.suggested_bin_id,
          actual_bin_id : post.actual_bin_id,
          // status    : statuss,
        }

      )

    });

    this.setState({
      loading_overlay: false,
      posts: posts ,
      filtered_orderData : posts,
      orderData : posts,
    })

    return posts;

  }
  assemblePosts1 = (data) => {

    let posts = data.map((post) => {
      var status = ""
      if (post.status == true) {
        status = "Active"
      } else { status = " Not Active" }
      var statuss = ""
      if (post.status == 0){
        statuss = "Created"
      }
      else if(post.status == 1){
        statuss = "Hold"
      }
      else if (post.status == 2){
        statuss = "Assigned"
      }
      else if (post.status == 3){
        statuss = "Confirmed"
      }
      else if(post.status == 111){
        statuss = "Canceled"
      }
    else if (post.status == 11){
      statuss = "Short Closed"
    }
      return (    
        
        {
          batch: post.batch_number,
          po_date:post.po_date,
          putaway_date:post.putaway_date,
          invoice_number : post.invoice_number,
          asn_number : post.asn_number,
          po_number :post.po_number,
          client : post.client,
          putaway_completetion_percentage : post.putaway_completetion_percentage,
          sku_count: post.sku_count,
          total_cld_count: post.received_cld_count,
          total_loose_count :post.received_loose_count,
          total_received_qty : post.total_received_qty,
          putaway_cld_count : post.putaway_cld_count,
          putaway_loose_count : post.putaway_loose_count,
          total_putaway_qty : post.total_qty,
          putaway_short_qty : post.putaway_short_qty,
          putaway_start_time:post.putaway_start_time,
          putaway_end_time:post.putaway_end_time,
          assigned_user:post.putaway_user,
          status    : statuss,
          // total_time_taken:post.total_time_taken
        }

      )

    });

    this.setState({
      loading_overlay: false,
      posts: posts ,
      filtered_orderData : posts,
      orderData : posts,
    })

    return posts;

  }

  processData() {

    this.setState({
      loading: true
    })

  }

  render() {
    
    const data = {


      columns: [
        {
          label: 'Batch',
          field: 'batch',
          sort: 'asc',
          width: 150,

        },
        {
          label: 'Invoice Number',
          field: 'invoice_number',
          sort: 'asc',
          width: 200,

        },
        {
          label: 'ASN Number',
          field: 'asn_number',
          sort: 'asc',
          width: 200,

        },
        {
          label: 'PO Number',
          field: 'po_number',
          sort: 'asc',
          width: 200,

        },
        {
          label: 'Client',
          field: 'client',
          sort: 'asc',
          width: 120,

        },
        {
          label: 'Product Code',
          field: 'product_code',
          sort: 'asc',
          width: 180,

        },
        {
          label: 'Product Name',
          field: 'product_name',
          sort: 'asc',
          width: 200,

        },

        {
          label: 'MRP',
          field: 'mrp',
          sort: 'asc',
          width: 120,

        },
        {
          label: 'UPC',
          field: 'upc',
          sort: 'asc',
          width: 120,

        },

        {
          label: 'Putaway Qty',
          field: 'total_qty',
          width: 120,
          sort: 'asc',

        },

        {

          label: 'Invoiced Qty',
          field: 'invoiced_qty',
          width: 120,
          sort: 'asc',

        },    

        {

          label: 'Total Received Qty',
          field: 'received_total_qty',
          width: 120,
          sort: 'asc',

        },
        {

          label: 'Received CLD Qty',
          field: 'received_cld_qty',
          width: 120,
          sort: 'asc',

        },
        {

          label: 'Received Loose Qty',
          field: 'received_loose_qty',
          width: 120,
          sort: 'asc',

        },
        {

          label: 'Confirmed Putaway Qty',
          field: 'total_putaway_qty',
          width: 120,
          sort: 'asc',

        },
        {

          label: 'Putaway CLD Qty',
          field: 'putaway_cld_qty',
          width: 120,
          sort: 'asc',

        },
        {

          label: 'Putaway Loose Qty',
          field: 'putaway_loose_qty',
          width: 120,
          sort: 'asc',

        },
        // {

        //   label: 'Putaway Short Qty',
        //   field: 'putaway_short_qty',
        //   width: 100,
        //   sort: 'asc',

        // },
        {

          label: 'PKM',
          field: 'pkm',
          width: 120,
          sort: 'asc',

        },
        {

          label: 'PO Date',
          field: 'po_date',
          width: 180,
          sort: 'asc',

        },

        {

          label: 'Inbound Del Date',
          field: 'inbound_del_date',
          width: 180,
          sort: 'asc',

        },
        {

          label: 'Putaway Date',
          field: 'putaway_date',
          width: 180,
          sort: 'asc',

        },

        {

          label: 'Putaway Through',
          field: 'putaway_through',
          width: 130,
          sort: 'asc',

        },

        {

          label: 'Putaway User',
          field: 'putaway_user',
          width: 150,
          sort: 'asc',

        },

        {

          label: 'Product scan time',
          field: 'product_scan_time',
          width: 130,
          sort: 'asc',

        },
        {

          label: 'Bin scan time',
          field: 'bin_scan_time',
          width: 130,
          sort: 'asc',

        },
        
        {
          label: 'Putaway Completion Time',
          field: 'putaway_completion_time',
          width: 130,
          sort: 'asc',
        },
        {
          label: 'Primary suggested Bin Id',
          field: 'suggested_bin_id',
          width: 150,
          sort: 'asc',
        },
        {
          label: 'Actual Scanned Bin Id',
          field: 'actual_bin_id',
          width: 150,
          sort: 'asc',
        },

        // {
        //   label: 'Status',
        //   field: 'status',
        //   width: 130,
        //   sort: 'asc',
        // },

      ],

      rows: this.state.tableRowsMap,

    }
    const data1 = {
     
      columns: [
         {
          label: 'Batch',
          field: 'batch',
          sort: 'asc',
          width: 130,

        },
        {
          label: 'PO Date',
          field: 'po_date',
          sort: 'asc',
          width: 150,

        },
        {
          label: 'Putaway Date',
          field: 'putaway_date',
          sort: 'asc',
          width: 150,

        },
        {
          label: 'Invoice Number',
          field: 'invoice_number',
          sort: 'asc',
          width: 180,

        },
        {
          label: 'ASN Number',
          field: 'asn_number',
          sort: 'asc',
          width: 180,

        },
        {
          label: 'PO Number',
          field: 'po_number',
          sort: 'asc',
          width: 180,

        },
        {
          label: 'Client',
          field: 'client',
          sort: 'asc',
          width: 120,

        },

        {
          label: 'Putaway completion percentage',
          field: 'putaway_completetion_percentage',
          sort: 'asc',
          width: 150,

        },
        {
          label: 'SKU Count',
          field: 'sku_count',
          sort: 'asc',
          width: 150,

        },

        {
          label: 'Total Cld Count',
          field: 'total_cld_count',
          sort: 'asc',
          width: 100,

        },

        {
          label: 'Total Loose Count',
          field: 'total_loose_count',
          width: 100,
          sort: 'asc',

        },
        {
          label: 'Total Qty',
          field: 'total_received_qty',
          width: 100,
          sort: 'asc',

        },

        {

          label: 'Putaway CLD Count',
          field: 'putaway_cld_count',
          width: 100,
          sort: 'asc',

        },

        {

          label: 'Putaway Loose Count',
          field: 'putaway_loose_count',
          width: 100,
          sort: 'asc',

        },
        {

          label: 'Putaway Total Qty',
          field: 'total_putaway_qty',
          width: 140,
          sort: 'asc',

        },
        {

          label: 'Putaway Short Qty',
          field: 'putaway_short_qty',
          width: 100,
          sort: 'asc',

        },
        {

          label: 'Putaway Start Time',
          field: 'putaway_start_time',
          width: 150,
          sort: 'asc',

        },

        {

          label: 'Putaway End Time',
          field: 'putaway_end_time',
          width: 150,
          sort: 'asc',

        },

        {

          label: 'Assigned User Ids',
          field: 'assigned_user',
          width: 150,
          sort: 'asc',

        },
        {
          label: 'Status',
          field: 'status',
          width: 130,
          sort: 'asc',
        },

      ],

      rows: this.state.tableRowsMap1,

    }
        
    return (
      <Col xl={12}>
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>

            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
         <Overlay>
            <form className="form">
             <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
                <span className="filter_title">Filters</span>
              </div>
          {(this.state.detailed_view ||  this.state.consolidated_view) &&
            <div>
             <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
              <span className="date_title">From Date</span>
              <div style={{ position: 'relative' }}>
              <DatePicker
                selected={this.state.from_date}
                onChange={this.FromDateChange}
                className="ledger_fromdate"
                placeholderText="From Date"
                format='yyyy-MM-dd'

              />
               <i className="fa fa-calendar" style={{ position: 'absolute', right: '10px', top: '10px', pointerEvents: 'none' }}></i>

              {this.state.showFromErr &&
                <span style={{ color: 'red', fontSize: 11 }}>Please Select From Date</span>
              }

              {this.state.dateOrderError && (
                <span style={{ color: 'red', fontSize: 11 }}>{this.state.fromDateError}</span>
              )}
            </div>
            </div>

             <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
              <span className="date_title">To Date</span>
              <div style={{ position: 'relative' }}>
              <DatePicker
                selected={this.state.to_date}
                onChange={this.ToDateChange}
                className="ledger_todate"
                placeholderText="To Date"
              />
               <i className="fa fa-calendar" style={{ position: 'absolute', right: '10px', top: '10px', pointerEvents: 'none' }}></i>
              {this.state.showToErr &&
                <span style={{ color: 'red', fontSize: 11 }}>Please Select To Date</span>
              }
              {this.state.dateRangeError &&
                <span style={{ color: 'red', fontSize: 11 }}>{this.state.toDateError}</span>
              }
            </div>
            </div>
            </div>
            }
            {(this.state.detailed_view ) &&
            <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                      <span className="date_title">Asn Number</span>
                      <div style={{ position: 'relative' }}>
                   <input type = "text" style={{height: 38}} className="form-control" placeholder= "Asn Number" onChange={this.onAsnChange}/>
                </div>
              </div>
            }
              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
              <span className="date_title">View Type</span>
              <div style={{ position: 'relative' }}>
               <select
                    className="form-control"
                    style={{ fontSize: 13 }}
                    onChange={this.handleChange}
                    // name="year"               
                  >
                    <option value="detailed_view">Select View Type</option>
                    <option value="detailed_view">Detailed View </option>
                    <option value="consolidated_view">Consolidated View </option>                   
                  </select>
                  </div>
                  </div>

             <div className="filter_button_container" style={{ width: '100%', marginBottom: '0px', float: 'left' }}>
                  <ButtonToolbar className="form__button-toolbar">
                <Button
                  className="btn-sm button_enable1 "
                  style={{
                    fontWeight: "normal",
                    textTransform: "capitalize",
                    borderRadius: 5,
                    backgroundColor: "#70bbfd",
                    color: "#fff",
                    padding: "5px 25px",
                    fontSize: "14px",
                    marginRight: '10px',
                  }}
                  id="button_view"
                  onClick={() => this.fetchInventoryData()}
                >
                  {this.state.loading && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  View
                </Button>
              
            { (this.state.detailed_view &&
          
               <Button
                    type="button"
                    className="btn btn-primary-outline"
                    style={{
                        cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                        backgroundColor: '#FFFFFF',
                        padding: "5px 10px",
                        color: '#333333', // Set text color
                        display: 'flex',   // Use flexbox to align image and text
                        alignItems: 'center' // Center items vertically
                    }}
                    id="button_download"
                     onClick={(e) => exportToCSVData(this.state.filtered_orderData, "Putaway Detailed Report")} 
                >
                    <img
                        src={DownloadIcon}
                        alt="Download"
                        style={{ width: '22px' }} // Adjust size as needed
                    />
                    Download
                </Button>

            
            )}
            { (this.state.consolidated_view &&
          
          <Button
               type="button"
               className="btn btn-primary-outline"
               style={{
                   cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                   backgroundColor: '#FFFFFF',
                   padding: "5px 25px",
                   color: '#333333', // Set text color
                   display: 'flex',   // Use flexbox to align image and text
                   alignItems: 'center' // Center items vertically
               }}
               id="button_download"
                onClick={(e) => exportToCSVData(this.state.filtered_orderData, "Putaway Consolidated Report")} 
           >
               <img
                   src={DownloadIcon}
                   alt="Download"
                   style={{ width: '25px' }} // Adjust size as needed
               />
               Download
           </Button>

       
       )}
            </ButtonToolbar>
            </div>
          

          </form>
          </Overlay>
           {!this.state.showfilterstatus && (
            <div style={{width: '80%', textAlign: 'center', padding: '12%'}}>
               <img style={{width: '10%'}} src={EmptyDataIcon} />
                <p className="noDataTextStyle">
                Choose your filters from the available options. The data will display
              </p>
              <p className="noDataTextStyle2">
                 here once the filters have been applied.
              </p>
            </div>


          )}
          {
            this.state.showFetchDispatchData && (
              <div>
            <div>

                <div className="date-container">
                 {From_Date_val}
                </div>


                <div className="date-container">
                 {to_Date_val}
                </div>

              </div>
            <div style={{ marginTop: '4%', paddingTop: 20, paddingBottom: 0 }}>
              {/*<hr style={{marginTop:'30px',marginBottom:'0px'}}/>*/}
              
              <div
                className="dispatchData stock_check_data"
                style={{ marginTop: -27 }}
              >
                <MDBDataTable
                  striped
                  bordered
                  scrollX
                  scrollY
                  sortable={false}
                  onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'Putaway Report', 'datatable_pagination_change' )}
                  hover
                  onSearch={this.filterData}
                  data={data}
                  maxHeight="390px"
                  
                />
              </div>
            </div>
            </div>

            )}
            {this.state.showFetchDispatchData1 && (
            <div>
            <div>

                <div className="date-container">
                 {From_Date_val}
                </div>


                <div className="date-container">
                 {to_Date_val}
                </div>

              </div>
            <div style={{ marginTop: '4%', paddingTop: 20, paddingBottom: 0 }}>
              {/*<hr style={{marginTop:'30px',marginBottom:'0px'}}/>*/}
              
              <div
                className="dispatchData stock_check_data"
                style={{ marginTop: -27 }}
              >
                <MDBDataTable
                  scrollX
                  scrollY
                  sortable={false}
                  maxHeight="390px"
                  onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'Putaway Report', 'datatable_pagination_change' )}
                  striped
                  bordered
                  onSearch={this.filterData}
                  data={data1}
                />
              </div>
            </div>
            </div>
          )}

        </Card>

      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));